import { Route, Routes, Link } from "react-router-dom";
import "./App.css";
import HomePage from "../src/pages/HomePage";
import Cursor from "./components/Cursor";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ContactUsPage from "./pages/ContactUsPage";
import NotFound from "./components/NotFound";
import ScrollToTopButton from "./components/TopButton";
import SmoothScrollWrapper from "./components/SmoothScroll";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Accessibility from "./components/Accessibility";
import TermsOfUse from "./components/TermsOfUse";
import ScrollToHashElement from "./components/ScrollHash";
import Attorney from "./components/Attorney";
import MainFooter from "./components/MainFooter";
import SiteMap from "./pages/SiteMap";
import MainservicePage from "./components/Services/MainservicePage";
import MRI from "./components/Services/ReadMore Pages/MRI/MRI";
import NoticePP from "./components/NoticePP";
import MedicalOfficer from "./components/About/MedicalOfficer";
import ForProviders from "./components/ForClinics/ForProviders";
import Resources from "./components/Resources";
import PET from "./components/Services/ReadMore Pages/PET/PET";
import CardiacAndVascular from "./components/Services/ReadMore Pages/Cardiac/CardiacAndVascular";
import ProstateImaging from "./components/Services/ReadMore Pages/Prostate/ProstateImaging";
import WomensImaging from "./components/Services/ReadMore Pages/Womens Imaging/WomensImaging";
import PersonalInjuryImaging from "./components/Services/ReadMore Pages/Personal Injury Imaging/PersonalInjuryImaging";
import Headerbar from "./components/Header/Headerbar";
import PatientContent from "./components/Patients/PatientContent";
import AboutPage from "./pages/AboutPage";
import CitrusAI from "./components/CitrusAI";
import CitrusFAQs from "./components/CitrusFAQs";
import PatietsBillIrights from "./components/PatietsBillIrights";
function App() {
  useEffect(() => {
    setTimeout(() => {
      Aos.init({
        duration: 1000,
        once: true,
        easing: "ease-in-out",
      });
    }, 0);
  }, []);
  return (
    <div>
      <Cursor />
      <SmoothScrollWrapper>
        <div>
          <div className="bottom-0 fixed grid grid-cols-2 lg:hidden  border-t border-black text-black text-[14px] lg:text-[16px] leading-[1.4em] z-50 font-bold bg-white w-full font-robout">
            <Link
              to="/contact-us"
              className="flex justify-center uppercase items-center py-3 w-full"
            >
              Contact
            </Link>
            <Link
              to="tel:3527959200"
              className="flex justify-center items-center w-full py-3 bg-black  font-normal text-[14px] lg:text-[16px] leading-[1.4em] text-white"
            >
              (352) 795-9200
            </Link>
          </div>
          <Headerbar />

          {/* 🔥 GLOBAL MOBILE HEADER SPACER */}
          <div className="block xl:hidden h-[86px]" />
          <ScrollToTopButton />
          <ScrollToHashElement offset={96} />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
            <Route path="/patient-portal" element={<PatientContent />} />
            <Route path="/healthcare-providers" element={<ForProviders />} />
            <Route path="/resources" element={<Resources />} />
            <Route
              path="/diagnostic-imaging-services"
              element={<MainservicePage />}
            />
            <Route path="/medical-privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/notice-of-privacy-practices" element={<NoticePP />} />
            <Route
              path="/accessibility-statement"
              element={<Accessibility />}
            />
            <Route path="/attorney" element={<Attorney />} />
            <Route path="/siteMap" element={<SiteMap />} />
            <Route path="/open-mri-and-imaging" element={<MRI />} />
            <Route path="/chief-medical-officer" element={<MedicalOfficer />} />
            <Route path="/pet-scan-imaging" element={<PET />} />
            <Route path="/cardiac-imaging" element={<CardiacAndVascular />} />
            <Route path="/prostate-on-mri" element={<ProstateImaging />} />
            <Route path="/womens-imaging-center" element={<WomensImaging />} />
            <Route
              path="/personal-injury"
              element={<PersonalInjuryImaging />}
            />
            <Route path="/advanced-ai-medical-imaging" element={<CitrusAI />} />
            <Route path="/faqs" element={<CitrusFAQs />} />
            <Route
              path="/patient-bill-of-rights"
              element={<PatietsBillIrights />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <MainFooter />
        </div>
      </SmoothScrollWrapper>
    </div>
  );
}
export default App;
